import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { TabView, TabPanel } from 'primereact/tabview';
import { useOrderData } from '../../hooks/useOrderData';
import { OverviewTab } from './OverviewTab';
import { LineItemsTab } from './LineItemsTab';
import { CustomerShippingTab } from './CustomerShippingTab';
import { ImageViewerDialog } from './ImageViewerDialog';
import { useLineItems } from '../../hooks/useLineItems';
import { useLineItemImages } from '../../hooks/useLineItemImages';
import { useCustomerShippingData } from '../../hooks/useCustomerShippingData';
import { useOrderSelection } from '../../hooks/useOrderSelection';
import { useLineItemSelection } from '../../hooks/useLineItemSelection';


interface ViewOrderInfoDialogProps {
  orderSelection: ReturnType<typeof useOrderSelection>;
  lineItemsHook: ReturnType<typeof useLineItems>;
  lineItemSelection: ReturnType<typeof useLineItemSelection>;
  visible: boolean;
  onHide: () => void;
}

export const ViewOrderInfoDialog: React.FC<ViewOrderInfoDialogProps> = ({
  orderSelection,
  lineItemsHook,
  lineItemSelection,
  visible,
  onHide,
}) => {
  
  const order = orderSelection.selectedOrder;
  const [activeIndex, setActiveIndex] = useState(0);
  
  // Use the new image hook
  const imageHook = useLineItemImages(lineItemsHook.selectedLineItem);
  const customerShippingDataHook = useCustomerShippingData(order?.order_id || null);

  const handleHide = () => {
    // Reset internal state
    setActiveIndex(0);
    
    // Call parent's onHide
    onHide();
  };

  return (
    <>
      <Dialog
        header="Order Information"
        visible={visible}
        onHide={handleHide}
        style={{ width: '90vw', maxWidth: '1200px', }}
        modal
        maximizable
        data-testid="view-order-info-dialog"
        footer={
          <div>
            <Button label="Close" icon="pi pi-times" onClick={handleHide} />
          </div>
        }
      >
        {order && (
          <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Overview">
              <OverviewTab order={order} />
            </TabPanel>
            
            <TabPanel header={`Line Items (${order.total_items})`}>
              <LineItemsTab 
                lineItemsHook={lineItemsHook}
                imageHook={imageHook}
              />
            </TabPanel>
            
            <TabPanel header="Customer & Shipping">
              <CustomerShippingTab customerShippingDataHook={customerShippingDataHook} />
            </TabPanel>
          </TabView>
        )}
      </Dialog>

      <ImageViewerDialog
        lineItemsHook = {lineItemsHook}
        imageHook = {imageHook}
      />
    </>
  );
};